'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialUsageUniqueItem(id, secret, usage) {
  this.xh = 0;
  this.xi = null;
  this.iw = null;
  this.xh = id;
  this.xi = secret;
  this.iw = usage;
}
export { $c_Lpresto_types$CredentialUsageUniqueItem as $c_Lpresto_types$CredentialUsageUniqueItem };
$p = $c_Lpresto_types$CredentialUsageUniqueItem.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialUsageUniqueItem;
/** @constructor */
function $h_Lpresto_types$CredentialUsageUniqueItem() {
}
export { $h_Lpresto_types$CredentialUsageUniqueItem as $h_Lpresto_types$CredentialUsageUniqueItem };
$h_Lpresto_types$CredentialUsageUniqueItem.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("CredentialUsageUniqueItem"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.xh);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.xi));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.iw));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().al(acc, 3);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$CredentialUsageUniqueItem)) {
    if ((this.xh === x$0.xh)) {
      var x = this.xi;
      var x$2 = x$0.xi;
      var $x_1 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.iw;
      var x$4 = x$0.iw;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "CredentialUsageUniqueItem";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.xh;
      break;
    }
    case 1: {
      return this.xi;
      break;
    }
    case 2: {
      return this.iw;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.jk = (function() {
  return this.xh;
});
function $isArrayOf_Lpresto_types$CredentialUsageUniqueItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jx)));
}
export { $isArrayOf_Lpresto_types$CredentialUsageUniqueItem as $isArrayOf_Lpresto_types$CredentialUsageUniqueItem };
var $d_Lpresto_types$CredentialUsageUniqueItem = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialUsageUniqueItem, "presto.types$CredentialUsageUniqueItem", ({
  jx: 1,
  aA: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$CredentialUsageUniqueItem as $d_Lpresto_types$CredentialUsageUniqueItem };
//# sourceMappingURL=presto.types$-Credential-Usage-Unique-Item.js.map
